import React, { useState, useEffect, Fragment } from 'react';
import { Table, Badge } from 'reactstrap';
import CustomTableHeader from '../../common/CustomTableHeader';
import CustomTableLoader from '../../common/CustomTableLoader';
import CustomTableEmptyRecord from '../../common/CustomTableEmptyRecord';
import { Link, useLocation } from 'react-router-dom';
import {
  AGENCY_CUSTOMER_EDIT_PAGE,
  AGENCY_COUPONS_EDIT_PAGE,
  AGENCY_SUBSCRIPTIONS_EDIT_PAGE,
} from '../../../utils/AppRoutes';
import Swal from 'sweetalert2';
import { getConfirm } from '../../../utils/functions/CustomFunctions';

function Invoice(props) {
  //state
  const [activeMenu, setActiveMenu] = useState('');
  let location = useLocation();
  const {
    tableColumns,
    listData = [],
    loading = false,
    deleteCustomer,
    deleteCoupons,
  } = props;

  //helper Function
  const statusShow = {
    success: <Badge color="success" >Success</Badge>,
    pending: <Badge color="warning">Pending</Badge>,
    Failed: <Badge color="danger">Failed</Badge>,
    Edit: <Badge color="info" className='.edit-badge'>Edit</Badge>,
    Delete: <Badge color="danger" className='.delete-badge'>Delete</Badge>,
  };

  const deleteSubcriptionSwal = (id) => {
    Swal.fire(
      getConfirm('warning', 'Are you sure do you want to delete?')
    ).then((result) => {
      if (result.isConfirmed) {
        deleteCustomer(id);
      }
    });
  };

  const deleteCouponsSwal = (id) => {
    Swal.fire(
      getConfirm('warning', 'Are you sure do you want to delete?')
    ).then((result) => {
      if (result.isConfirmed) {
        deleteCoupons(id);
      }
    });
  };

  useEffect(() => {
    let currentMenuToActive = window.location.pathname.split('/')[1] || '/';
    setActiveMenu(currentMenuToActive);
  }, [location]);

  return (
    <div>
      <Table className="invoice-table">
        <CustomTableHeader tableColumns={tableColumns} />
        <tbody>
          {loading ? (
            // Table Loader
            <CustomTableLoader columnsCount={tableColumns.length} />
          ) : (
            <>
              {!listData.length ? (
                //  Empty Record
                <CustomTableEmptyRecord columnsCount={tableColumns.length} />
              ) : (
                <>
                  {!listData.length ? (
                    //  Empty Record
                    <CustomTableEmptyRecord
                      columnsCount={tableColumns.length}
                    />
                  ) : (
                    //  Empty Record
                    <>
                      {activeMenu == 'customer' &&
                        listData.map((record, key) => (
                          <tr key={key}>
                            <td>{record.customerName || '-'}</td>
                            <td>{record.email || '-'}</td>
                            <td>(+1) {record.phoneNumber || '-'}</td>
                            <td>{record.createdDate || '-'}‎</td>
                            <td
                              style={{ display: 'flex', alignItems: 'center' }}
                            >
                              <Link
                                to={{
                                  pathname:
                                    AGENCY_CUSTOMER_EDIT_PAGE +
                                    '/' +
                                    record.customerId,
                                }}
                                className="gape-link"
                              >
                                {statusShow['Edit']}
                              </Link>
                              <div
                                onClick={() =>
                                  deleteSubcriptionSwal(record.customerId)
                                }
                                style={{ cursor: 'pointer' }}
                                className="gape-link"
                              >
                                {statusShow['Delete']}
                              </div>
                            </td>
                          </tr>
                        ))}

                      {activeMenu == 'subscriptions' &&
                        listData.map((record, key) => (
                          <tr key={key}>
                            <td>{record.invoiceNumber || '-'}</td>
                            <td>{record.customerName || '-'}</td>
                            <td>{record.invoiceSendInterval || '-'}</td>
                            <td>{record.subscriptionStartDate || '-'}‎</td>
                            <td>{record.subscriptionEndDate || '-'}‎</td>
                            <td>
                              {parseFloat(record.paymentAmount).toFixed(2) ||
                                '-'}
                            </td>
                            <td>
                              <Link
                                to={{
                                  pathname:
                                    AGENCY_SUBSCRIPTIONS_EDIT_PAGE +
                                    '/' +
                                    record.subscriptionId,
                                }}
                                className="gape-link"
                              >
                                {statusShow['Edit']}
                              </Link>
                              <Link
                                to="#"
                                onClick={() =>
                                  deleteSubcriptionSwal(record.subscriptionId)
                                }
                                className="gape-link"
                              >
                                {statusShow['Delete']}
                              </Link>
                            </td>
                          </tr>
                        ))}
                      {activeMenu == 'coupons' &&
                        listData.map((record, key) => (
                          <tr key={key}>
                            <td>{record.couponCode || '-'}</td>
                            <td>{record.userCount || '0'}</td>
                            <td>
                              {parseFloat(record.discountPercentage).toFixed(
                                2
                              ) || '-'}
                            </td>
                            <td>{record.createdDate || '-'}‎</td>
                            <td>
                              <Link
                                to={{
                                  pathname:
                                    AGENCY_COUPONS_EDIT_PAGE +
                                    '/' +
                                    record.couponId,
                                }}
                                className="gape-link"
                              >
                                {statusShow['Edit']}
                              </Link>
                              <Link
                                to="#"
                                onClick={() =>
                                  deleteCouponsSwal(record.couponId)
                                }
                                className="gape-link"
                              >
                                {statusShow['Delete']}
                              </Link>
                            </td>
                          </tr>
                        ))}
                    </>
                  )}
                </>
              )}
            </>
          )}
        </tbody>
      </Table>
    </div>
  );
}
export default Invoice;
